<template>
  <div id="app">
    <suspense>
      <router-view />
    </suspense>
    <div id="message-box" />

    <div id="mloading" class="loading">
      <!-- <div class="loadingio-spinner-dual-ball-p4fazz803e">
        <div class="ldio-z76ep1av69">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div> -->
      <div class="loading-cover" />
      <div class="loading-svg">
        <div class="effect-1 effects" />
      </div>
    </div>
    <modals-container />
    <dialog-wrapper />
    <div class="fake-click" />

    <div
      class="tool-feature-container right"
      :style="{
        left: positionTransfrom.left == 'unset' ? positionTransfrom.left : positionTransfrom.left + 'vw',
        top: positionTransfrom.top == 'unset' ? positionTransfrom.top : positionTransfrom.top + 'vh',
        right: positionTransfrom.right == 'unset' ? positionTransfrom.right : positionTransfrom.right + 'vw',
        bottom: positionTransfrom.bottom == 'unset' ? positionTransfrom.bottom : positionTransfrom.bottom + 'vh',
      }"
      :class="[{hovered: isHovered}]"
      @mousemove="startDrag"
      @mousedown="handleMouseDown"
      @mouseup="handleMouseUp"
    ></div>

    <div id="msg-box-nps" class="msg-box-nps" style="display: none">
      <div id="msg-center-nps" class="form-popup-nps msg-center-nps">
        <iframe id="msg-content-nps" frameborder="0" />
      </div>
    </div>
  </div>
</template>

<script>
import {DialogWrapper} from 'vue3-promise-dialog';
import ToolsFeatureButton from '@/views/toolFeature/ToolsFeatureButton.vue';
import {useContextStore} from '@/stores/contextStore';
export default {
  mixins: [ToolsFeatureButton],
  components: {
    DialogWrapper,
  },
  data() {
    return {
      isOffLiveChat: window._off_livechat,
    };
  },
  computed: {
    useLiveChat() {
      return window?.useLiveChat;
    },
  },
  watch: {},
  created() {},

  async mounted() {
    const me = this;
    me.initEnterSameTab();

    const contextStore = useContextStore();

    window.addEventListener(
      'popstate',
      function (event) {
        let context = contextStore.context;
        if (!context?.DatabaseId) {
          // logout
          commonFn.logoff();
        }
      },
      false,
    );
  },
  methods: {
    /**
     * next control khi ấn Enter
     */
    initEnterSameTab() {
      const me = this;

      window.addEventListener('keydown', function (e) {
        if (e.which === 13 && !e.shiftKey) {
          const tag = e.target.tagName.toLowerCase();
          if (['button', 'a'].indexOf(tag) > -1) {
            return;
          }

          if ('textarea' == tag && e.shiftKey) {
            return;
          }
          // Nếu sự kiện xảy ra ở grid thì không bắt sự kiện ở hàm này nữa. Trong grid đã xử lý.
          // Thêm kiểm tra phải là control nhập liệu trong bođy thì mới bỏ qua
          if (e.target.closest('.ms-grid-viewer') && e.target.closest('tbody')) {
            return;
          }
          // ntphong 27/5/2021 - với control có class remain-focus-when-enter thì không focus sang control tiếp theo khi ấn enter
          if (e.target.closest('.remain-focus-when-enter')) {
            return;
          }
          const focusable = me.$ms.commonFn.focusNextControl(e.target);
          if (focusable) {
            e.preventDefault();
          }
        }
      });
    },
  },
};
</script>

<style lang="scss"></style>
